import { any, array, boolean, coerce, Describe, number, object, optional, string, type } from 'superstruct';

import prefixHttps from '~utils/prefixHttps';

const PermissionGroupValidator = object({
  id: number(),
  label: string(),
  active: boolean(),
});

export const PermissionsResponseValidator: Describe<PermissionsResponse> = object({
  view: array(PermissionGroupValidator),
  download: array(PermissionGroupValidator),
});

export const MamAssetUrlValidator: Describe<MamAssetUrlDto> = type({
  url: coerce(string(), any(), value => {
    if (typeof value === 'string') {
      if (value.startsWith('#')) {
        return '';
      }
      return prefixHttps(value);
    }
    return '';
  }),
});

export const MamAssetValidator: Describe<MamAssetDto> = type({
  id: number(),
  type: string(),
  attributes: type({
    title: string(),
    filesize_formatted: string(),
    fileextension: coerce(string(), any(), () => ''),
    filename: string(),
  }),
  actions: type({
    download: optional(boolean()),
    myFiles: optional(boolean()),
    raiseRequest: optional(boolean()),
  }),
  previews: type({
    details: coerce(string(), any(), value => {
      if (typeof value === 'string') {
        return prefixHttps(value);
      }
      return '';
    }),
  }),
});

export const MamAssetsValidator: Describe<MamAssetsDto> = array(MamAssetValidator);
